<template>
  <div>
    <MissionHeaderBlock>QUIZ : Comprendre le diabète</MissionHeaderBlock>
    <ContextBlock>Vous arrivez bientôt au terme de votre parcours "Comprendre le diabète". C'est le bon moment pour vérifier que vous acquis quelques notions essentielles au sujet du diabète. Si vous hésitez dans vos réponses, n'oubliez pas que toutes vos vidéos et vos fiches santé sont disponibles en permanence dans votre MÉDIATHÈQUE. À vous de jouer !</ContextBlock>
    <ObjectivesBlock> tester ses connaissances tout en s'amusant !</ObjectivesBlock>
    <InstructionsBlock>Pour réussir cette mission, vous devez :<br> 1 - Répondre intégralement au questionnaire proposé<br> 2 - VALIDER la mission.
    </InstructionsBlock>
    <TrueFalseCarouselBlock :questions="mission.module.config.quizz"
                            @finished="endQuiz($event)"></TrueFalseCarouselBlock>
    <FinishMissionButtonBlock :loading="ui.loading"
                              v-if="finished"
                              class="mt-10"
                              @click.native="finishMission">Valider la mission
    </FinishMissionButtonBlock>
  </div>
</template>

<script>
  import api from 'api'
  import ContextBlock from 'components/blocks/ContextBlock'
  import InstructionsBlock from 'components/blocks/InstructionsBlock'
  import ObjectivesBlock from 'components/blocks/ObjectivesBlock'
  import FinishMissionButtonBlock from '../../../../../../blocks/FinishMissionButtonBlock'
  import MissionHeaderBlock from '../../../../../../blocks/MissionHeaderBlock'
  import TrueFalseCarouselBlock from '../../../../../../blocks/TrueFalseCarouselBlock'

  export default {
    components: {
      FinishMissionButtonBlock,
      ContextBlock,
      ObjectivesBlock,
      InstructionsBlock,
      MissionHeaderBlock,
      TrueFalseCarouselBlock
    },

    data () {
      return {
        ui: {
          loading: false
        },
        finished: false,
        missionData: {}
      }
    },

    methods: {
      endQuiz (data) {
        this.finished = true
        this.missionData = data
      },

      finishMission () {
        this.ui.loading = true
        this.errors = {}

        api.post(`missions/${this.mission.id}`, this.missionData)
          .then(res => {
            this.$mango.snackbar({
              color: 'success',
              text: "Mission validée. Bravo !"
            })
            this.$router.push({name: 'patient@dashboard'})
          })
          .catch(err => {
            this.$mango.snackbar({
              color: 'error',
              text: "Erreur de validation. Veuillez vérifier le formulaire."
            })
          })
          .then(() => {
            this.ui.loading = false
          })
      }
    },

    props: {
      mission: {
        required: true,
        type: Object
      }
    }
  }
</script>
